/**
 * @generated SignedSource<<01dc6457aec57696970cbdd8d2922349>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NonUserDefragSurveyQuery$variables = {
  emailInstanceId: string;
};
export type NonUserDefragSurveyQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NonUserDefragSurvey_viewer">;
  };
};
export type NonUserDefragSurveyQuery = {
  variables: NonUserDefragSurveyQuery$variables;
  response: NonUserDefragSurveyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emailInstanceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "emailInstanceId",
    "variableName": "emailInstanceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NonUserDefragSurveyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "NonUserDefragSurvey_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NonUserDefragSurveyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nonUserDefragEmailResponse",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "responseType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "additionalInformation",
                    "storageKey": null
                  }
                ],
                "type": "NonUserDefragEmailResponse",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0431da68395fe8a70cf3dbd8d61ed2c",
    "id": null,
    "metadata": {},
    "name": "NonUserDefragSurveyQuery",
    "operationKind": "query",
    "text": "query NonUserDefragSurveyQuery(\n  $emailInstanceId: String!\n) {\n  viewer {\n    ...NonUserDefragSurvey_viewer_3P730v\n    id\n  }\n}\n\nfragment NonUserDefragSurvey_viewer_3P730v on Viewer {\n  nonUserDefragEmailResponse(emailInstanceId: $emailInstanceId) {\n    __typename\n    ... on NonUserDefragEmailResponse {\n      responseType\n      additionalInformation\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5b1402c5eb9668fcf9e66c70eb9f62d";

export default node;
